import React, { ChangeEvent, SyntheticEvent } from "react";
import { HttpsRequest, GetAuth, Alerts } from '../component/Utils';
import MenuComp, { PageTitle } from "../component/menucomp";
import Pagination from "../component/Paginator"
import { FaEdit } from "react-icons/fa";
import { URLENUM } from "../component/Texts";
import { FormGroup } from '../component/form';
import { Loading, BoxArea, ActionBar } from "../component/BaseComponent";
import { TbDeviceNintendo } from "react-icons/tb";


type TrackerUIProp = {
}

type TrackDataProp = {
    id: number;
    device_info: number;
    device_serial_no: string;
    sim_phone: string;
    date_created: string;
    asset_type: number;
    vehicle_name: string;
    plate_no: string;
    status: string;
    edit_func: (deviceid: number) => void
}

type TrackerUIState = {
    body: TrackDataProp[];
    isbusy: boolean;
    pager: PagerType,
    edit_mode: boolean;
    form: Record<string, any>[];
    data: Record<string, number | string | unknown>
}

class TrackerUI extends React.Component<TrackerUIProp, TrackerUIState> {

    constructor(props: TrackerUIProp) {
        super(props);
        this.state = {
            body: [],
            isbusy: true,
            pager: {
                next_page: 0,
                page: 1, pages: [],
                prev_page: 0, total: 0, rows: 10
            },
            edit_mode: false,
            form: [],
            data: {}
        }
    }

    fetch_callback = (resp: callbackType) => {

        if (resp.status === -1) {
            alert(resp.errormsg)
            this.setState({
                isbusy: false
            })
            return false
        }

        const body = resp.body
        this.setState({
            body: body['data'],
            isbusy: false,
            pager: {
                page: body['page'],
                pages: body['pages'],
                prev_page: body['prev_page'],
                total: body['total'],
                next_page: body['next_page'],
                rows: this.state.pager.rows
            }
        });

    }

    componentDidMount(): void {
        HttpsRequest.get(URLENUM.device, this.fetch_callback, GetAuth())
    }

    refresh_page = (page: number, rows?: string) => {

        HttpsRequest.get(URLENUM.device, this.fetch_callback, GetAuth(), { 'page': String(page), "rows": rows || '10' })

        const { pager } = this.state
        pager.rows = rows ? Number(rows) : 10
        this.setState({ isbusy: true, pager: pager });
    }

    onchange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {

        const name: string = target.name;
        const value: string = target.value;
        const checked: boolean = target.checked;
        const type: string = target.type;

        if (type === 'checkbox') {
            this.setState({ data: Object.assign({}, this.state.data, { [name]: checked }) });
            return;
        }

        this.setState({ data: Object.assign({}, this.state.data, { [name]: value }) });

    }

    edit_callback = (resp: callbackType) => {

        if (resp.status !== 0) {
            Alerts.show_error(resp.errormsg!);
            this.setState({
                isbusy: false
            })
            return null
        }

        this.setState({
            form: resp.body.formdata,
            data: resp.body.rawdata,
            isbusy: false,
            edit_mode: true
        })

    }

    load_edit_form = (deviceid: number): void => {

        HttpsRequest.get(
            URLENUM.device_edit + `${deviceid}`,
            this.edit_callback,
            GetAuth()
        )

        this.setState({
            isbusy: true
        })

    }

    update_callback = (resp: callbackType) => {

        if (resp.status !== 0) {

            this.setState({
                form: resp.body.formdata,
                isbusy: false
            })

            return
        }

        this.setState({
            edit_mode: false
        }, () => this.refresh_page(1))

    }

    publish_update = (event: SyntheticEvent<HTMLFormElement>) => {
        event.preventDefault();

        const content = this.state.data;
        HttpsRequest.post(
            URLENUM.device_edit + `${content.id}`,
            content,
            this.update_callback, GetAuth()
        )

        this.setState({ isbusy: true })

    }
    selectchange = (event: ChangeEvent<HTMLSelectElement>) => {
        const { data } = this.state;
        const { name, value } = event.target;
        data[name] = event.target.value
        this.setState({ data })
    }

    render() {
        let sidecls = this.state.edit_mode ? "col-md-6" : "col-md-8";

        return (
            <div>
                <MenuComp />
                <br />
                <br />
                <ActionBar
                    classname={sidecls}
                    placeholder={"search"}
                    search={false}
                    btntitle={"New Tracker"}
                    btnicon={<TbDeviceNintendo size={20} />}
                />
                <br />
                <br />

                <div className="container-fluid">
                    <div className="row posrel">

                        <BoxArea classname={sidecls + ' posrel'} >

                            <PageTitle title={'Tracker Devices'} />

                            <div className="table-responsive posrel">
                                <table className="table table-condensed table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <td> Date </td>
                                            <td> Vehicle Name </td>
                                            <td> Vehicle No </td>
                                            <td> Tracker Serial NO</td>
                                            <td> Tracker Sim </td>
                                            <td> Asset Type </td>
                                            <td> Status </td>
                                            <td> Action </td>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {
                                            this.state.body.length === 0 ? <tr> <td colSpan={8} className="center"> <i> no data found...</i></td> </tr> : (
                                                this.state.body.map((item, idx) => <TableRow key={`tr-${idx}`} {...item} edit_func={this.load_edit_form} />)
                                            )
                                        }
                                    </tbody>
                                </table>

                                <Pagination {...this.state.pager} navigate={this.refresh_page} />
                            </div>
                            <div>
                                {this.state.isbusy && <Loading />}
                            </div>

                        </BoxArea>

                        {
                            this.state.edit_mode ? (
                                <BoxArea classname={'col-md-6'} >
                                    <PageTitle title={'Tracker Update'} />
                                    <br />
                                    <form method='post' autoComplete="off" onSubmit={this.publish_update}>
                                        {
                                            this.state.form.map((fld, idx) => {
                                                return <FormGroup
                                                    key={`device-${idx}`}
                                                    obj={fld} onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                        this.onchange(e);
                                                    }}
                                                    onselectchange={this.selectchange}
                                                />;
                                            })
                                        }

                                        <div className="mb-4 mt-4 padv5">
                                            <div className="form-group row">
                                                <div className="d-flex justify-content-around">
                                                    <div className="d-grid gap-2 col-3">
                                                        <button type="submit" className="btn btn-primary btn-lg">
                                                            Save Changes
                                                        </button>
                                                    </div>
                                                    <div className="d-grid gap-2 col-3">
                                                        <button type="button" onClick={() => this.setState({ edit_mode: false })} className="btn btn-light btn-lg">
                                                            &nbsp;&nbsp; Close &nbsp;&nbsp;
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </BoxArea>


                            ) : null
                        }
                        
                    </div>

                </div>
            </div>

        )
    }

}

const TableRow = ({ date_created, vehicle_name, plate_no, sim_phone,
    id, asset_type, device_serial_no, device_info, status, edit_func
}: TrackDataProp) => (
    <tr>
        <td data-attr={`${id}-${device_info}`}> {date_created}</td>
        <td> {vehicle_name} </td>
        <td> {plate_no} </td>
        <td> {device_serial_no}</td>
        <td> {sim_phone}</td>
        <td> {asset_type}</td>
        <td> {
            status ? (<span className="text-white badge bg-success"> Active </span>
            ) : (
                <span className="text-white badge bg-danger"> In-Active </span>
            )}
        </td>
        <td>
            <button className="btn btn-light btn-sm" onClick={() => edit_func(id)}> <FaEdit /> &nbsp; Edit </button>
        </td>
    </tr>
)

export default TrackerUI;